<template>
    <div class="train-form">
        <div text-type="h6" text-bottom="2" text-color="default">{{ $t("chatbotv2.selectStory") }}</div>
        <a-select :value="selectedStoryId" @change="(e) => (selectedStoryId = e)" class="select-block">
            <a-select-option :value="story._id" v-for="story of allStories" :key="story._id">
                <span class="blockTypeText">{{ story.title }}</span>
            </a-select-option>
        </a-select>
        <div text-type="h6" text-bottom="2" text-color="default" class="mt-2">{{ $t("chatbotv2.selectBlock") }}</div>
        <a-select
            :value="selectedBlockId"
            class="select-block"
            showSearch
            :placeholder="$t('chatbotv2.selectBlock')"
            @change="handleSelectBlockChange"
            @search="handleSelectBlockSearch"
            @select="handleSelectBlockSelect"
            :notFoundContent="$t('chatbotv2.noBlocksFound')"
            size="large"
            :filter-option="false"
        >
            <a-select-option :value="block.id" v-for="block of getInputBlocks()" :key="block.id">
                <div class="block-row">
                    <BlockIconPreview :block-type="block.type" class="img" />
                    <span class="blockTypeText">{{ block.name || $t(`chatbotv2.${block.type}`) }}</span>
                </div>
            </a-select-option>
        </a-select>

        <div class="train-phrases-buttons">
            <a-button @click="onCancel">{{ $t("message.cancel") }}</a-button>
            <a-button
                class="ml-3"
                type="primary"
                :disabled="!selectedStoryId || !selectedBlockId"
                @click="() => onTrain(selectedStoryId, storyVersion, selectedBlockId)"
                >Train
            </a-button>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import _ from "lodash";
import BlockIconPreview from "../dashboard/common/BlockIconPreview";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import flatDiagram from "../../utils/flatDiagram";
import BLOCK_TYPES from "../../block.types";

const log = log2("TrainForm");
export default {
    name: "TrainForm",
    components: { BlockIconPreview },
    props: {
        allStories: {
            type: Array,
            default: () => [],
        },
        defaultSelectedStoryId: {
            type: String,
            default: null,
        },
        onCancel: {
            type: Function,
            default: () => {},
        },
        onTrain: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            selectedStoryId: this.defaultSelectedStoryId || _.get(this.allStories[0], "_id"),
            selectedBlockId: null,
            storyVersion: null,
            diagram: null,
            query: null,
        };
    },
    methods: {
        handleSelectBlockChange(blockId) {
            log(`selected ${blockId}`);
            this.selectedBlockId = blockId;
            this.query = "";
        },
        handleSelectBlockSelect(blockId) {
            log(`handleSelectBlockSelect ${blockId}`);
            this.selectedBlockId = blockId;
        },
        handleSelectBlockSearch(search) {
            log(`handleSearch ${search}`);
            this.query = search;
        },
        fetchDraftBoard() {
            log("fetchDraftBoard");
            CHATBOT_API.getStoryDraftDetail({
                id: this.selectedStoryId,
            }).then((res) => {
                log("fetchDraftBoard", res.data);
                const { data, errors } = res.data;
                if (!!data) {
                    this.diagram = data.board.diagram;
                    this.storyVersion = data.board.version;
                }
            });
        },
        getInputBlocks() {
            if (this.diagram) {
                const flattedDiagram = flatDiagram(this.diagram);
                const q = this.query || "";
                return flattedDiagram
                    .filter((block) => block.type === BLOCK_TYPES.USER_INPUT)
                    .filter(
                        (block) =>
                            _.isEmpty(q) ||
                            (block.name || "").toLowerCase().includes(q) ||
                            block.type.toLowerCase().includes(q)
                    )
                    .map((x) => ({
                        id: x.id,
                        type: x.type,
                        name: x.name,
                    }));
            }

            return [];
        },
    },
    mounted() {
        if (this.selectedStoryId) {
            this.fetchDraftBoard();
        }
    },
    watch: {
        defaultSelectedStoryId(newVal) {
            this.selectedStoryId = newVal;
        },
        selectedStoryId(id) {
            this.selectedBlockId = null;
            this.diagram = null;
            this.storyVersion = null;
            this.fetchDraftBoard();
        },
    },
};
</script>

<style lang="scss">
[text-bottom="2"] {
    margin-bottom: 10px;
}

[text-color="default"] {
    color: #22272d;
}

[text-type="h6"] {
    font-size: 15px;
    line-height: 19px;
}

.block-row {
    padding: 0px 17px;
    height: 45px;
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 10px;

    .material-icons {
        font-size: 20px;
    }

    &:hover {
    }
}

.train-form {
    width: 270px;
    padding: 15px;

    .train-phrases-buttons {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        .ant-button:first-child {
            margin: 0px 10px 0px 0px;
            min-width: 80px;
        }
    }
}

.select-block {
    width: 100%;

    .ant-select-selection--single {
        height: 43px;
    }
}
</style>
